import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';

export const GENERIC_FILTER_TEMPLATE_GENERAL_DATA_SAVED = gql`
  subscription genericFilterTemplateGeneralDataSaved {
    genericFilterTemplateGeneralDataSaved {
      data {
        id
        name
        isTemplate
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const GENERIC_FILTER_TEMPLATE_DETAILS_SAVED = gql`
  subscription genericFilterTemplateDetailsSaved {
    genericFilterTemplateDetailsSaved {
      data {
        id
        phrase
        conditions {
          id
          templateId
          paramId
          operatorId
          value
          valueId
          orderNo
          values {
            id
            detailId
            value
            valueId
          }
        }
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
